import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import useTranslation from "../../client/hooks/useTranslation";

interface OverviewKpisProps {
  kpis: {
    totalClicks: number;
    referredSignups: number;
    payingConversions: number;
    conversionRate: number;
  };
  isDark: boolean;
}

export default function OverviewKpis({ kpis, isDark }: OverviewKpisProps) {
  const t = useTranslation();

  const items = [
    { label: t.affiliate.kpis.clicks, value: String(kpis.totalClicks) },
    { label: t.affiliate.kpis.signups, value: String(kpis.referredSignups) },
    {
      label: t.affiliate.kpis.conversions,
      value: String(kpis.payingConversions),
    },
    {
      label: t.affiliate.kpis.conversionRate,
      value: `${kpis.conversionRate.toLocaleString()} %`,
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map((item) => (
        <Card key={item.label} className="h-full flex flex-col">
          <CardSectionHeader label={item.label} isDark={isDark} compact />
          <CardContent className="px-4 pb-4 pt-2 flex-1 flex flex-col justify-center">
            <p className="text-2xl font-bold font-mono leading-none tabular-nums text-foreground">
              {item.value}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
